import request from '@/util/request'

/**
 * 获取录音分页列表
 * @param {Object} params 查询参数
 * @param {number} params.size 每页大小
 * @param {number} params.number 页码
 * @param {string} params.imei 设备IMEI
 * @param {string} params.keyword 搜索关键词
 */
export function audioPage(data) {
  return request({
    url: '/device/audioRecord/page',
    method: 'post',
    data
  })
}

/**
 * 删除录音
 * @param {Object} data 请求数据
 * @param {string} data.str 要删除的录音ID，多个ID用逗号分隔
 */
export function audioDel(data) {
  return request({
    url: '/device/audioRecord/del',
    method: 'post',
    data
  })
}

/**
 * 清空设备录音
 * @param {string} imei 设备IMEI
 */
export function audioClean(imei) {
  return request({
    url: '/device/audioRecord/clean/' + imei,
    method: 'delete'
  })
}

/**
 * 请求设备录音
 * @param {Object} data 请求数据
 * @param {string} data.imei 设备IMEI
 */
export function deviceAudioRecordReq(data) {
  return request({
    url: '/device/audioRecord/req',
    method: 'post',
    data
  })
}
/**
 * 请求录音余额
 * @param {Object} imei 请求数据
 */
export function getAudioBalanceInfo(imei) {
  return request({
    url: '/device/audioRecord/balance/' + imei,
    method: 'get'
  })
}

/**
 * 请求录音模式
 * @param {Object} imei 请求数据
 */
export function getAudioModel(imei) {
  return request({
    url: '/device/audio/model/' + imei,
    method: 'get'
  })
}
